import { useState, useEffect } from "react";
import FlightBooking from "../FlightBooking/FlightBooking";
import TravelTabs from "./TravelTabs";
import HotelSearchForm from "../HotelSearchForm/HotelSearchForm";
import BusBooking from "../Busbooking/BusBooking";
import { useLocation, useNavigate } from "react-router-dom";

const Slider = ({ type = "home" }) => {
  const [activeTab, setActiveTab] = useState("flight");
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get("tab");

    if (tabFromUrl && ["flight", "hotel", "bus"].includes(tabFromUrl)) {
      setActiveTab(tabFromUrl);
      const newParams = new URLSearchParams(location.search);
      newParams.delete("tab");
      const newSearch = newParams.toString();
      navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ""}`, { replace: true });
    }

    const handleSetActiveTab = (event) => setActiveTab(event.detail.tabType);
    window.addEventListener("setActiveTab", handleSetActiveTab);
    return () => window.removeEventListener("setActiveTab", handleSetActiveTab);
  }, [location, navigate]);

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "hotel":
        return <HotelSearchForm />;
      case "bus":
        return <BusBooking />;
      case "flight":
      default:
        return <FlightBooking />;
    }
  };

  if (!isHome) {
    // Compact mode: reused on result pages just to modify the current search.
    return <div className="slider-container">{renderActiveTabContent()}</div>;
  }

  return (
    <div className="slider-container relative bg-ink-50">
      {/* Subtle decorative accents, kept light — this wrapper has its own overflow-hidden so the
          blur circles (positioned outside their box) don't cause page-level scroll. Deliberately
          NOT on the outer slider-container itself, since that would also clip the date-picker
          popup rendered inside the search card below (it's absolutely positioned and can extend
          past this container's edge). */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 -right-32 h-80 w-80 rounded-full bg-brand-100/60 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-sky-accent/10 blur-3xl" />
      </div>

      <div className="relative max-w-[1280px] mx-auto px-5 sm:px-6 pt-12 sm:pt-16 pb-8 sm:pb-10">
        <p className="text-xs font-bold tracking-[0.14em] text-brand-600 uppercase mb-3 text-center sm:text-left">
          India's Travel Companion
        </p>
        <h1 className="text-ink-900 text-[28px] sm:text-[42px] font-extrabold tracking-tight text-center sm:text-left max-w-2xl leading-[1.15]">
          Fly, Stay &amp; Travel — Made Simple.
        </h1>
        <p className="text-ink-500 text-[15px] sm:text-base mt-3 text-center sm:text-left max-w-xl">
          Compare and book Flights, Hotels &amp; Bus tickets at India's best prices.
        </p>

        <div className="mt-8 sm:mt-9">
          <TravelTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>

      {/* Search card sits directly in the light hero, no heavy overlap shadow */}
      <div className="relative max-w-[1280px] mx-auto px-4 sm:px-6 pb-12 sm:pb-16">
        <div className="bg-white rounded-2xl border border-ink-100 shadow-card p-4 sm:p-6">
          {renderActiveTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Slider;
